// For Loading
export const TOGGLE_LOADING = 'TOGGLE_LOADING'
// For Unauthorization 
export const UNAUTHORIZED_CONVERSATION = "UNAUTHORIZED_CONVERSATION"
// for conversation listing
export const FETCH_CONVERSATION_LIST = "FETCH_CONVERSATION_LIST"
export const FETCH_CONVERSATION_DATA = "FETCH_CONVERSATION_DATA"
// for Message list
export const FETCH_MESSAGE_LIST = "FETCH_MESSAGE_LIST"
